import {
    TIME_OUT,
    BASE_URL,
} from "./config";
import axios from "axios";
import { message } from "ant-design-vue";
import { createStringManager } from "@/utils/timeManage";

const manager = createStringManager(5000);
console.log('BASE_URL====', BASE_URL)
const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL || "/", // 适配本地和线上
    timeout: TIME_OUT,
});
api.interceptors.request.use(
    (config) => {
        // 设置默认请求头
        config.headers = {
            ...config.headers,
            'X-Request-StoreId':document.querySelector("meta[name='storeId']")?.content,
            'X-Request-Language':document.querySelector("meta[name='language']")?.content,
            'X-Request-CountryCode':document.querySelector("meta[name='country']")?.content,
            // 'cookie':'leid=xxxxx'
        };
        // if (config.url && config.url.startsWith('/api/')) {
        //     const countryCode = document.querySelector("meta[name='country']")?.content || 'cz';
        //     const languageCode = document.querySelector("meta[name='language']")?.content || 'cs';
            
        //     // 将 /api/ 替换为 /{country}/{language}/api/
        //     config.url = config.url.replace('/api/', `/${countryCode}/${languageCode}/api/`);
        // }

        // 后面优化一下
        const token = localStorage.getItem("auth") && JSON.parse(localStorage.getItem("auth"))?.userInfo?.token;
        if (token) {
            config.headers.Authorization = `${token}`;
            config.headers.KMUUID = crypto.randomUUID();
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const setRouter = (router) => {
    // 响应拦截器，处理通用错误
    api.interceptors.response.use(
        (response,config) => {
            if ( response.data.code === 456 ) {
                // 重定向到登陆页面
                router.push({name: 'Login', query: { redirectType: 456 }});
                return;
            } else if ( response.data.code === 401 ) {
                if(!manager.hasString(response.data.msg)) {
                    message.error(response.data.msg);
                }
                manager.addString(response.data.msg);
                setTimeout(() => {
                    router.push({name: 'Login', query: { redirectType: 401 }});
                }, 1000);
                return;
            }
            return response.data
        },
        (error) => {
            console.error("API Error:", error.response?.data || error.message);
            return Promise.reject(error);
        }
    );
}

const mergeRequest = async (url, data) => {
    const headers = {
        'Accept': 'application/json;odata=verbose',
        'Content-Type': 'application/json',
        'X-HTTP-Method': 'MERGE',
        "content-type": "application/json;odata=verbose",
    };

    const merge = requestInterceptor({url, headers});

    try {
        const response = await axios({
            method: 'merge',
            url,
            data,
            ...merge
        });
        return response.data;
    } catch (error) {
        console.error('Error with MERGE request:', error);
        throw error;
    }
};

const deleteRequest = async (url, params, config) => {
    const merge = requestInterceptor({url, ...config});
    try {
        const response = await axios.delete(url, {params, ...merge});
        return response.data;
    } catch (error) {
        if (error.response.status === 423) {
            return error.response;
        }
        console.error('Error with MERGE request:', error);
        throw error;
    }
};

export { api, mergeRequest, deleteRequest };
